import { Component } from '@angular/core';
import { LandingStartBookingComponent } from "../../shared/start-booking/start-booking.component";
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'landing-business-pricing',
    imports: [LandingStartBookingComponent],
    templateUrl: './pricing.component.html',
    styleUrl: './pricing.component.scss'
})
export class LandingBusinessPricingComponent {
    assetUrl = environment.assetBaseUrl
}
